module.exports = __webpack_public_path__ + "static/media/IBM-GenAI.ecc27152.jpg";